import { render, staticRenderFns } from "./Approve.vue?vue&type=template&id=4c1fe08f&"
import script from "./Approve.vue?vue&type=script&lang=js&"
export * from "./Approve.vue?vue&type=script&lang=js&"
import style0 from "./Approve.vue?vue&type=style&index=0&id=4c1fe08f&prod&lang=css&"
import style1 from "./Approve.vue?vue&type=style&index=1&id=4c1fe08f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports